<div class="flex-column gap-32">

    @if (isLoading()) {
        <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
    } @else {

        <app-card preCardTitle="Cartegraph management" icon="arrow_back" (iconClicked)="navigateBack()">
            <div *appCardContent class="settings-header-container">
                <div class="settings-header-title">
                    <p>Manage Cartegraph import filters</p>
                    <div class="settings-header-subtitle">
                        Adjust driver, vehicle, material and other import filters.
                    </div>
                </div>
            </div>

            <div *appCardContent>
                <app-cartegraph-settings-import></app-cartegraph-settings-import>
            </div>

            <div *appCardContent>
                <form [formGroup]="form">
                    @for (filter of filters; track $index) {
                        <ng-container *ngTemplateOutlet="filterTpl;context:{form: form, filter: filter}"></ng-container>
                    }

                    <ng-container *ngTemplateOutlet="filterVehicleGroups;context:{form: form}"></ng-container>
                </form>
            </div>
        </app-card>

        @if (isTesting || !!filterResults) {
            <app-card>
                <div *appCardContent class="settings-header-container mb-16">
                    <div class="settings-header-title"><p> Filter result preview</p></div>
                    <div class="settings-header-actions">
                        <button mat-stroked-button
                                color="accent"
                                [disabled]="isTesting"
                                (click)="filterResults = null;">
                            <span>Close</span>
                        </button>
                    </div>
                </div>
                <div *appCardContent>
                    <div>
                        @if (isTesting) {
                            <div class="mt-15 flex-row align-items-start">
                                <mat-spinner diameter="30" color="accent" class="spinner"></mat-spinner>
                                Loading results ...
                            </div>
                        } @else {
                        <ol class="scrollable">
                            @for (result of filterResults; track $index) {
                                <li><span class="w-100px">{{ result }}</span></li>
                            } @empty {
                                No results ...
                            }
                        </ol>
                        }
                    </div>
                </div>
            </app-card>
        }
    }

</div>


<ng-template #filterTpl let-form="form" let-filter="filter">
    <!-- filter template -->
    <div class="field-row" [formGroup]="form">
        <div class="field-row-title">
            {{ filter.title }}
        </div>
        <div class="field-row-element">
            <mat-form-field appearance="outline" color="accent" class="form-input">
                <input type="text" matInput
                       [placeholder]="filter.placeholder"
                       [formControlName]="filter.controlName">
                @if (filter.required && form.controls[filter.controlName].hasError('required')) {
                    <mat-error>
                        Field is required
                    </mat-error>
                }
            </mat-form-field>
            @if (filter.hasTest) {
                <button
                        mat-stroked-button
                        color="accent"
                        class="ml-10"
                        (click)="onTestClick(filter.controlName)"
                        [disabled]="!(form.controls[filter.controlName].valid) || isTesting">
                    @if (isTesting) {
                        <mat-icon [ngClass]="isTesting ? 'spin': ''">published_with_changes</mat-icon>
                    } @else {
                        <mat-icon>play_circle</mat-icon>
                    }
                    Test
                </button>
            }
        </div>
    </div>
</ng-template>


<ng-template #filterVehicleGroups let-form="form">
    <!-- vehicle groups grouping -->
    <div class="field-row" [formGroup]="form">
        <div class="field-row-title">
            Vehicle grouping field
        </div>
        <div class="field-row-element">
            @if (equipmentClassFields && equipmentClassFields.length > 0) {
                <app-row-with-select formControlName="vehicleGroupField"
                                     [list]="equipmentClassFields"
                                     listId="name"
                                     listLabel="displayName"
                ></app-row-with-select>
            } @else {
                <input type="text" matInput
                       placeholder="Vehicle's group field e.g. 'DepartmentField'"
                       formControlName='vehicleGroupField'
                       name="vehicleGroupField">
            }
            @if (form.controls['vehicleGroupField'].hasError('required')) {
                <mat-error>
                    Field is required
                </mat-error>
            }
        </div>
    </div>
</ng-template>
